<template>
  <table class="tableSize flipTable">
    <tr>
      <template v-for="(head, n) in tableHeader" >
        <th class="tableHeader" v-if="!(isExcel && head === '랜딩페이지')" :key="n">

          {{head}}
        </th>
      </template>
    </tr>
    <tbody>
      <tr v-for="(data, index) in viewData" :key="index">
        <td class="header">
          <div>
            <a class="name" @click="clickHandler(data.creative_url, data.size_nm, data)">
              {{setCreativeNm(data)}}
            </a>
          </div>
        </td>
        <td class="sortCenter" v-if="!isExcel">
          <a :href="data.landing_url" target="_blank" v-if="checkLanding(data.landing_url)">보기</a>
        </td>
        <td class="sortCenter">
          <div class="data_wrap">
            {{parseDataType(data.imp_cnt)}}
          </div>
        </td>
        <td class="sortCenter" v-if="campaignType !== 'CPCV'">
          <div class="data_wrap">
            {{parseDataType(data.click_cnt)}}
          </div>
        </td>
        <td class="sortCenter" v-if="isInterPlay && isCampaignType(campaignType)">
          <div class="data_wrap">
            {{ parseDataType(data.click_cnt) }}
          </div>
        </td>
        <td class="sortCenter" >
          <div class="data_wrap">
            {{ data.ctr.toFixed(2) }}
          </div>
        </td>
        <td class="sortCenter" v-if="isInterPlay && !isCampaignType(campaignType)">
          <div class="data_wrap">
            {{ parseDataType(data.view_cnt) }}
          </div>
        </td>

        <td class="sortCenter" v-if="isInterPlay && campaignType !== 'CPCV' ">
          <div class="data_wrap">
           {{isNaN(data.vtr) ? 0 : data.vtr.toFixed(1)}}
          </div>
        </td>
        <td class="sortCenter" v-if="isInterPlay && campaignType === 'HIP'">
          <div class="data_wrap">
            {{parseDataType(data.play_cnt)}}
          </div>
        </td>
        <td class="sortCenter" v-if="isInterPlay && isCampaignType(campaignType)">
          <div class="data_wrap">
            {{parseDataType(data[isCampaignTypeDataKey()])}}
          </div>
        </td>
        <td class="sortCenter" v-if="isInterPlay">
          <div class="data_wrap">
            {{parseDataType(data.play_sec_avg)}}
          </div>
        </td>
        <td class="sortCenter" v-if="isInterPlay">
          <div class="data_wrap">
            {{parseData(data.end_rate, 'rate')}}
          </div>
        </td>
        <td class="sortCenter" v-if="isInterPlay">
          <div class="data_wrap">
            {{parseData(data.play_Q1_rate, 'rate')}}
          </div>
        </td>
        <td class="sortCenter" v-if="isInterPlay">
          <div class="data_wrap">
            {{parseData(data.play_Q2_rate, 'rate')}}
          </div>
        </td>
        <td class="sortCenter" v-if="isInterPlay">
          <div class="data_wrap">
            {{parseData(data.play_Q3_rate, 'rate')}}
          </div>
        </td>
      </tr>
      <tr>
        <td class="sortCenter total"><b>합계</b></td>
        <td v-if="!isExcel"></td>
        <th v-for="(data, key) in totalKey" class="sortCenter" :key="key">
          <div class="data_wrap">
            {{ campaignType !== 'CPCV' && data === 'vtr' ? 100.0 : parseData(totalData[data], data) }}
          </div>
        </th>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import _ from 'lodash'
  import { parseDataType, parseData, isInterPlay } from '@/assets/func'

  export default {
    name: 'name',
    props: {
      campaignType: String,
      viewData: Array,
      isExcel: Boolean,
      tab: String
    },
    data () {
      return {
        header: [
          '소재명',
          '랜딩페이지',
          '노출수',
          '클릭수',
          'CTR(%)'
        ],
        ipHeader: [
          '소재명',
          '랜딩페이지',
          '노출수',
          '클릭수',
          'CTR(%)',
          'VIEW',
          'VTR(%)',
          '재생수',
          '평균재생(초)',
          '재생완료(%)',
          '재생Q1(%)',
          '재생Q2(%)',
          '재생Q3(%)'
        ],
        cvHeader: [
          '소재명',
          '랜딩페이지',
          '노출수',
          '클릭수',
          'CTR(%)',
          'VIEW',
          'VTR(%)',
          'VIEW + CLICK',
          '평균재생(초)',
          '재생완료(%)',
          '재생Q1(%)',
          '재생Q2(%)',
          '재생Q3(%)'
        ],
        cpcvHeader: [
          '소재명',
          '랜딩페이지',
          '노출수',
          '클릭수',
          'CTR(%)',
          '시청완료',
          '평균재생(초)',
          '재생완료(%)',
          '재생Q1(%)',
          '재생Q2(%)',
          '재생Q3(%)'
        ]
      }
    },
    methods: {
      parseDataType (data) {
        return parseDataType(data)
      },
      parseData (data, key) {
        return parseData(data, key)
      },
      checkLanding (url) {
        return url !== 'x'
      },
      isCampaignType () {
        this.campaignType
        switch (this.campaignType) {
          case 'CPCV' :
            return true
          case 'CPV' :
            return false
          default :
            if (this.campaignType.indexOf('CV') > -1) return true // 'IP', 'AIP', 'OHIP', 'JIP', 'HIP'
            else return false
        }
      },
      isCampaignTypeDataKey () {
        switch (this.campaignType) {
          case 'CPCV' :
            return 'cpcv'
          case 'CPV' :
            return false
          default :
            if (this.campaignType.indexOf('CV') > -1) return 'cpvc' // 'IP', 'AIP', 'OHIP', 'JIP', 'HIP'
            else return false
        }
      },
      getSize (adKnd, creativeNm) {
        switch (adKnd) {
          case 'OHIP':
            return 'M640_360_FULL'
          case 'SOHIP':
            return 'M300_230_PLUS'
          case 'IP':
            if (creativeNm.split('/')[3].trim().replace(/(.png|.jpg|.jpeg|.gif|.mp4)$/, '') === '970_250') return '970_250_FULL'
            else return '640_360_FULL'
          case 'SIP':
            if (creativeNm.split('/')[3].trim().replace(/(.png|.jpg|.jpeg|.gif|.mp4)$/, '') === '970_250') return '970_250_PLUS'
            else return '640_360_PLUS'
          case 'FIP':
            return '640_360_PERF'
          case 'FOHIP':
            return 'M640_360_PERF'
          case 'DIP':
            return '640_360_SAVE'
          case 'DOHIP':
            return 'M640_360_SAVE'
          case 'C06OHIP':
            return 'M640_360_06'
          case 'C06IP':
            return '640_360_06'
          case 'C15IP':
            return '640_360_15'
          case 'C15OHIP':
            return 'M640_360_15'
          case 'EX2':
            return 'P300_250'
          default :
            return ''
        }
      },
      clickHandler (url, size, data) {
        if (this.isExcel) return
        let z = ''
        if (size.indexOf('M') > -1) {
          z = (size.substr(1, size.length - 1)).split('x')
        } else {
          z = size.split('x')
        }
        let x = Math.floor((screen.availWidth - parseInt(z[0])) / 2)
        let y = Math.floor((screen.availHeight - parseInt(z[1])) / 2)
        const getSize = this.getSize(this.setCreativeKrNm_kr(data.ad_knd), data.creative_nm)
        const urlSplit = url.split('/')
        const urlCustom = (getSize === '' || getSize === 'P300_250') ? url : url.replace(urlSplit[urlSplit.length - 1], getSize + '.mp4')
        window.open(urlCustom,
          '_blank',
          'width=' + z[0] + ',height=' + (getSize === 'P300_250' ? 250 : z[1]) +
          ',top=' + y + ',left=' + x + ',status=no,toolbar=no,scrollbars=no')
      },
      getTotalData (dataList) {
        let result = {}

        result.imp_cnt = _.sumBy(dataList, function (o) { return o.imp_cnt * 1 })
        result.click_cnt = _.sumBy(dataList, function (o) { return o.click_cnt * 1 })
        result.ctr = result.click_cnt / result.imp_cnt * 100
        if (this.isInterPlay) {
          let view = _.sumBy(dataList, function (o) { return o.view_cnt * 1 })
          let playCnt = _.sumBy(dataList, function (o) { return o.play_cnt * 1 })
        //   let cpvc = _.sumBy(dataList, function (o) { return o.cpvc * 1 })
          let vtr = view / (playCnt || result.imp_cnt) * 100
          result.view = isNaN(view) ? 0 : view
          result.vtr = isNaN(vtr) ? 0 : vtr
        //   if (this.campaignType.indexOf('CV') > -1) result.cpvc = cpvc
          if (this.campaignType === 'CPCV') result.view_cnt = _.sumBy(dataList, function (o) { return o.cpcv * 1 })
          else if (this.campaignType === 'CPV') result.view_cnt = _.sumBy(dataList, function (o) { return o.view_cnt * 1 })
          else if (this.campaignType.indexOf('CV') > -1) result.view_cnt = _.sumBy(dataList, function (o) { return o.cpvc * 1 })
        }
        return result // 사이즈별 일자별 리포트, 사이즈/일자별리포트, 사이즈별 리포트 합계
      },
      setCreativeKrNm (data) {
        return data.creative_kr_nm
      },
      getTargeting (nm) {
        if (nm === undefined) return
        const targeting = nm.split('/')[1]
        switch (targeting) {
          case 'CM':
            return '문맥매칭'
          case 'GT':
            return '지역매칭'
          case 'RT':
            return '리타겟팅'
          case 'AT':
            return '오디언스'
          case 'NK':
            return '비매칭'
          default:
            return '비매칭'
        }
      },
      whatKindOfCreative (adKnd) {
        switch (adKnd) {
          case 'OHIP':
            return '풀스크린(모바일)'
          case 'SOHIP':
            return '브랜드PLUS(모바일)'
          case 'IP':
            return '풀스크린'
          case 'SIP':
            return '브랜드PLUS'
          case 'FIP':
            return '퍼포먼스'
          case 'FOHIP':
            return '퍼포먼스(모바일)'
          case 'DIP':
            return '세이브'
          case 'DOHIP':
            return '세이브(모바일)'
          case 'C06IP':
            return '쇼츠06'
          case 'C06OHIP':
            return '쇼츠06(모바일)'
          case 'C15IP':
            return '쇼츠15'
          case 'C15OHIP':
            return '쇼츠15(모바일)'
          case 'EX2':
            return '팝업'
          case 'XIP':
            return 'PC BOX'
          default :
            return '배너'
        }
      },
      setCreativeKrNm_kr (adKnd) {
        switch (adKnd) {
          case 'OHIP':
          case 'EOHIP':
          case 'AOHIP':
          case 'GOHIP':
          case 'VOHIP':
          case 'VGOHIP':
          case 'VEOHIP':
          case 'VAOHIP':
          case 'CVOHIP':
          case 'CVAOHIP':
          case 'CVGOHIP':
            return 'OHIP'
          case 'SOHIP':
          case 'ESOHIP':
          case 'VESOHIP':
          case 'ASOHIP':
          case 'GSOHIP':
          case 'VSOHIP':
          case 'VGSOHIP':
          case 'VASOHIP':
          case 'CVSOHIP':
          case 'CVASOHIP':
          case 'CVGSOHIP':
            return 'SOHIP'
          case 'FOHIP':
          case 'EFOHIP':
          case 'VEFOHIP':
          case 'AFOHIP':
          case 'GFOHIP':
          case 'VFOHIP':
          case 'VGFOHIP':
          case 'VAFOHIP':
          case 'CVFOHIP':
          case 'CVAFOHIP':
          case 'CVGFOHIP':
            return 'FOHIP'
          case 'DOHIP':
          case 'VDOHIP':
          case 'VEDOHIP':
          case 'VGDOHIP':
          case 'VADOHIP':
            return 'DOHIP'
          case 'C06OHIP':
          case 'C06EOHIP':
          case 'C06AOHIP':
          case 'C06GOHIP':
            return 'C06OHIP'
          case 'C15OHIP':
          case 'C15EOHIP':
          case 'C15AOHIP':
          case 'C15GOHIP':
            return 'C15OHIP'
          case 'C06IP':
          case 'C06EIP':
          case 'C06AIP':
          case 'C06GIP':
            return 'C06IP'
          case 'C15IP':
          case 'C15EIP':
          case 'C15AIP':
          case 'C15GIP':
            return 'C15IP'
          case 'IP':
          case 'EIP':
          case 'AIP':
          case 'GIP':
          case 'VIP':
          case 'VEIP':
          case 'VAIP':
          case 'VGIP':
          case 'CVIP':
          case 'CVAIP':
          case 'CVGIP':
            return 'IP'
          case 'SIP':
          case 'ESIP':
          case 'ASIP':
          case 'GSIP':
          case 'VSIP':
          case 'VESIP':
          case 'VASIP':
          case 'VGSIP':
          case 'CVSIP':
          case 'CVASIP':
          case 'CVGSIP':
            return 'SIP'
          case 'FIP':
          case 'EFIP':
          case 'AFIP':
          case 'GFIP':
          case 'VEFIP':
          case 'VFIP':
          case 'VAFIP':
          case 'VGFIP':
          case 'CVFIP':
          case 'CVAFIP':
          case 'CVGFIP':
            return 'FIP'
          case 'DIP':
          case 'VEDIP':
          case 'VDIP':
          case 'VADIP':
          case 'VGDIP':
            return 'DIP'
          case 'EX2':
          case 'AEX2':
          case 'GEX2':
          case 'CVEX2':
          case 'CVAEX2':
          case 'CVGEX2':
            return 'EX2'
          case 'XIP':
          case 'EXIP':
          case 'AXIP':
          case 'GXIP':
            return 'XIP'
          default :
            return 'BA'
        }
      },
      setCreativeNm (data) {
        if (data.creative_nm === undefined) return
        return this.whatKindOfCreative(this.setCreativeKrNm_kr(data.ad_knd)) + '_' + this.getTargeting(data.creative_nm) + '_' + (data.creative_kr_nm ? this.setCreativeKrNm(data) : data.creative_nm.split('/')[2]) + '_' + data.creative_nm.split('/')[3].trim().replace(/(.png|.jpg|.jpeg|.gif|.mp4)$/, '')
      }
    },
    computed: {
      totalData () {
        return this.getTotalData(this.viewData)
      },
      totalKey () {
        let base = ['imp_cnt', 'click_cnt', 'ctr']
        let ip = ['imp_cnt', 'click_cnt', 'ctr', 'view', 'vtr']
        let cv = ['imp_cnt', 'click_cnt', 'ctr', 'view', 'vtr', 'cpvc']
        let cpvc = ['imp_cnt', 'click_cnt', 'ctr', 'view_cnt']
        // let cpcv = ['imp_cnt', 'vtr', 'click_cnt', 'ctr', 'cpcv']

        if (!this.isInterPlay) {
          return base
        } else {
          if (this.campaignType === 'CPCV') return cpvc
          else if (this.campaignType.indexOf('CV') > -1) {
            return cv
          } else if (this.campaignType === 'CPVC') {
            return cpvc
          } else {
            return ip
          }
        }
      },
      isInterPlay () {
        return isInterPlay()
      },
      tableHeader () {
        if (!this.isInterPlay) {
          return this.header
        } else {
          switch (this.campaignType) {
            case 'CV':
            case 'CPV':
              return this.ipHeader.filter(function (header) {
                return header !== '재생수'
              })
            case 'CVPIP':
              return this.cvHeader
            case 'CPCV':
              return this.cpcvHeader
            case 'HIP':
              return this.ipHeader
            default :
              return this.ipHeader.filter(function (header) {
                return header !== '재생수'
              })
          }
        }
      }
    }
  }
</script>

<style scoped>
  .name:hover {
    cursor: pointer;
  }
  .header {
    width: 35%;
  }
  .header div {
    padding-left: 20px;
    text-align: left;
  }

  @media screen and (max-width: 600px) {
    .header div {
      width: 100%;
      height: 60px;
      padding-left: 0;
      overflow: hidden;
      white-space: normal;
      text-align: left;
      word-wrap: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .tableHeader:first-child {
      line-height: 60px;
      height: 60px;
    }
    .header {
      width: 60px;
      -ms-word-break: break-all;
      word-break:break-all;
      white-space: initial;
      height: 60px;
      line-height: 20px;
    }
    .total {
      text-align: center;
      line-height: 30px;
      height: 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// CreativeTable.vue?f946e91a